import React, { Component } from 'react';
import { Modal, Button } from "react-bootstrap"
import { withTranslation } from 'react-i18next';

class AuthorDeleteConfirm extends Component {

    constructor(props) {
        super(props)
        this.state = {
            transPage: "modals.author_delete."
        }

        this.deleteSelectedAuthor = this.deleteSelectedAuthor.bind(this)
        this.onOpenModal = this.onOpenModal.bind(this)
        this.onCloseModal = this.onCloseModal.bind(this)
    }


    deleteSelectedAuthor() {
        // dari props method nya
        this.props.deleteSelectedAuthor() 
    }

    onCloseModal(){
        this.props.onHide()
    }

    onOpenModal() {

    }

    render() {
        const {t} = this.props;
        const listUsers = this.props.selectedAuthor.map(item => {
            return (<li key={item.id}>{item.name}</li>)
        })

        return (
            <Modal show={this.props.show} onHide={() => this.onCloseModal()} onShow={() => this.onOpenModal()}>
                {this.props.loadingModal}
                <Modal.Header closeButton className="bg-danger">
                    <Modal.Title>{t(this.state.transPage + "title")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>{t(this.state.transPage + "confirmation_text")}</p>
                    <ul>
                        {listUsers}
                    </ul>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => this.onCloseModal()}>
                        {t('cancel')}
                    </Button>
                    <Button variant="danger" onClick={() => this.deleteSelectedAuthor()}>
                        <i className="fa fa-trash">&nbsp;</i>
                        {t(this.state.transPage + "delete_author")}
                    </Button>   
                </Modal.Footer>
            </Modal>
        );
    }
}

export default withTranslation()(AuthorDeleteConfirm);